import {
	STORAGE_TAPROOT_ADDRESS,
	STORAGE_PUBLIC_KEY,
	STORAGE_WALLET_TYPE,
	NETWORK
} from '@/utils/constants'
import SafeLocalStorage from '../safe-local-storage'
import * as btc from '@scure/btc-signer'
import Wallet from './'
import { WalletProvider } from '@/utils/types/wallet'
import * as bitcoin from 'bitcoinjs-lib'

import { isUserRejection } from './signing-errors'

export default class DogelabsWallet implements WalletProvider {
	get name(): string {
		return 'Doge Labs'
	}

	get capabilities(): string[] {
		return []
	}

	get connectIcon(): string {
		return '/connect-dogelabs.svg'
	}

	get enabled(): boolean {
		return NETWORK === 'DOGE'
	}

	async connect(): Promise<boolean> {
		// @ts-ignore
		if (!window.dogeLabs) {
			window.open('https://drc-20.org/', '_blank')
			return false
		}

		await this.login()
		return true
	}

	async login(): Promise<void> {
		// @ts-ignore
		if (!window.dogeLabs) {
			throw new Error('Dogelabs is not installed. Install the extension, then reconnect.')
		}

		const { address, public_key } = await (window as any).dogeLabs
			.requestAccounts()
			.then(async ([address]: string[]) => ({
				address,
				public_key: await (window as any).dogeLabs.getPublicKey()
			}))
		localStorage.setItem(STORAGE_TAPROOT_ADDRESS, address)
		localStorage.setItem(STORAGE_WALLET_TYPE, 'dogelabs')
		localStorage.setItem(STORAGE_PUBLIC_KEY, public_key)
		try {
			await Wallet.fetchProfile()
		} catch (_e) {}
	}

	async listenForAccountChange(): Promise<void> {
		// @ts-ignore
		if (!window.dogeLabs || Wallet.type() !== 'dogelabs') {
			return
		}

		// @ts-ignore
		window.dogeLabs.on('accountsChanged', async () => {
			await this.login()
			window.location.reload()
		})
	}

	async dummyPsbt(_inscription_id: string): Promise<string> {
		const tx = new btc.Transaction({ version: 0, lockTime: 0 })
		const non_witness_tx = new btc.Transaction({ version: 0, lockTime: 0 })
		const { script } = btc.p2pkh(Buffer.from(Wallet.getPublicKey(), 'hex'))
		non_witness_tx.addOutput({ script, amount: BigInt(1e8) })
		non_witness_tx.addInput({
			txid: '0000000000000000000000000000000000000000000000000000000000000000',
			index: 0,
			sequence: 4294967295,
			finalScriptSig: Buffer.from('00', 'hex')
		})
		tx.addOutput({ script, amount: BigInt(1e8) })
		tx.addInput({
			txid: non_witness_tx.id,
			index: 0,
			sequence: 4294967295,
			nonWitnessUtxo: non_witness_tx.hex
		})
		const psbt = Buffer.from(tx.toPSBT()).toString('hex')
		return psbt
	}

	taprootAddress(): string {
		return SafeLocalStorage.getItem(STORAGE_TAPROOT_ADDRESS)
	}

	async signPSBT(psbt: string): Promise<string> {
		try {
			let psbtBytes = Buffer.from(psbt, 'hex')
			let psbt_tx
			try {
				psbt_tx = btc.Transaction.fromPSBT(psbtBytes)
			} catch (_e) {
				// @ts-ignore
				const network = bitcoin.networks.mainnet
				const temp = bitcoin.Psbt.fromHex(psbt, { network })
				psbt_tx = btc.Transaction.fromPSBT(Buffer.from(temp.toHex(), 'hex'))
			}

			;(psbt_tx as any).inputs.map((e: any, i: any) => {
				;(psbt_tx as any).inputs[i].tapBip32Derivation = []
				;(psbt_tx as any).inputs[i].bip32Derivation = []
			})

			;(psbt_tx as any).outputs.map((e: any, i: any) => {
				;(psbt_tx as any).outputs[i].tapBip32Derivation = []
				;(psbt_tx as any).outputs[i].bip32Derivation = []
			})

			psbtBytes = Buffer.from(psbt_tx.toPSBT())
			const psbtHex = Buffer.from(psbtBytes).toString('hex')

			// @ts-ignore
			const data = await window.dogeLabs.signPsbt(psbtHex)
			let tx = btc.Transaction.fromPSBT(Buffer.from(data, 'hex'))
			return Buffer.from(tx.toPSBT()).toString('hex')
		} catch (e) {
			console.log(e)
			throw e
		}
	}

	async signPSBTExtractTx(psbt: string): Promise<string> {
		try {
			// @ts-ignore
			const data = await this.signPSBT(psbt)
			let tx = btc.Transaction.fromPSBT(Buffer.from(data, 'hex'))
			return Buffer.from(tx.extract()).toString('hex')
		} catch (e) {
			console.log(e)
			throw e
		}
	}

	async signMessage(message: String): Promise<string> {
		try {
			// @ts-ignore
			const res = await window.dogeLabs.signMessage(message, 'bip322-simple')
			return res
		} catch (_e) {
			return undefined as unknown as string
		}
	}

	async signInscribe(psbt: string): Promise<string> {
		return this.signPSBTExtractTx(psbt)
	}

	async signTransfer(psbt: string): Promise<string> {
		return this.signPSBTExtractTx(psbt)
	}

	async signEscrow(psbt: string): Promise<string> {
		return this.signPSBT(psbt)
	}

	async signPurchase(
		setup_psbt: string,
		purchase_psbt: string
	): Promise<{ signedSetup: string; signedPurchase: string }> {
		try {
			let signedSetup = ''
			let setup_tx

			if (setup_psbt) {
				// @ts-ignore
				const signedSetupPSBT = await window.dogeLabs.signPsbt(setup_psbt)
				setup_tx = btc.Transaction.fromPSBT(Buffer.from(signedSetupPSBT, 'hex'))
				signedSetup = Buffer.from(setup_tx.extract()).toString('hex')
			}

			let purchase_tx = btc.Transaction.fromPSBT(Buffer.from(purchase_psbt, 'hex'))

			if (setup_psbt) {
				// @ts-ignore
				const replace_txid = Buffer.from(purchase_tx.inputs[0].txid).toString('hex')
				// @ts-ignore
				const setup_txid = Buffer.from(setup_tx.id, 'hex')
				// @ts-ignore
				purchase_tx.inputs.forEach((e, i) => {
					// @ts-ignore
					const txid = Buffer.from(purchase_tx.inputs[i].txid).toString('hex')

					if (txid == replace_txid) {
						// @ts-ignore
						purchase_tx.inputs[i].txid = setup_txid
						// @ts-ignore
						purchase_tx.inputs[i].nonWitnessUtxo = btc.Transaction.fromRaw(
							Buffer.from(signedSetup, 'hex')
						)
					}
				})
			}

			// @ts-ignore
			const signedPurchase = await window.dogeLabs.signPsbt(
				Buffer.from(purchase_tx.toPSBT()).toString('hex')
			)

			return { signedSetup, signedPurchase }
		} catch (e) {
			if (isUserRejection(e)) {
				return undefined as unknown as { signedSetup: string; signedPurchase: string }
			}
			console.log(e)
			throw e
		}
	}
}
